import { MarkSpec, NodeSpec, Schema } from 'prosemirror-model';

export class WorkingSchema {
  constructor(readonly schema) {}

  extendNodes(ext: Record<string, NodeSpec>) {
    return new WorkingSchema(
      new Schema({
        marks: this.schema.spec.marks,
        nodes: (this.schema.spec.nodes as any).append(ext),
      }),
    );
  }

  extendMarks(ext: Record<string, MarkSpec>) {
    return new WorkingSchema(
      new Schema({
        nodes: this.schema.spec.nodes,
        marks: (this.schema.spec.marks as any).append(ext),
      }),
    );
  }
}

export function take(schema: Schema) {
  return new WorkingSchema(schema);
}
